var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('v-alert',{style:({
    'margin': !_vm.isSimulation && _vm.isDesktop ? '15px 30px 15px 30px' : '15px' 
  }),attrs:{"color":_vm.content.Color,"dense":"","text":"","icon":_vm.content.Icon,"border":"left"}},[_vm._v(" "+_vm._s(_vm.getTranslation(_vm.content.AlertText, _vm.locale))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }